import { appBridge, isEmbedded } from '@/config';
import toastSlice from '@/redux/slice/toast.slice';
import { Message } from '@shoplinedev/appbridge';

const useHandleToastNotEmbedded = () => {
  const show = (value: string, isError?: boolean) => {
    toastSlice.actions.handleToast({ isOpen: true, content: value, error: isError });
  };
  return {
    show,
  };
};

const useHandleToast = () => {
  const show = (value: string, isError?: boolean) => {
    try {
      Message.create(appBridge).open({
        messageInfo: value,
        type: isError ? 'error' : 'success', //success | warning | info | error
      });
    } catch (e) {
      toastSlice.actions.handleToast({ isOpen: true, content: value, error: isError });
    }
  };

  return {
    show,
  };
};

export default isEmbedded ? useHandleToast : useHandleToastNotEmbedded;
